import { graphql } from "@/gql";

export const updateUserMutation = graphql(`
  mutation UpdateUserMutation($id: ID!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      id
    }
  }
`);

export const deleteUserMutation = graphql(`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`);

export const adminResetUserPasswordMutation = graphql(`
  mutation AdminResetUserPassword($id: ID!, $password: String!) {
    adminResetUserPassword(id: $id, password: $password)
  }
`);

export const addUserToOrganisationMutation = graphql(`
  mutation AddUserToOrganisation($organisation_id: ID!, $user_id: ID!) {
    addOrganisationMember(
      organisation_id: $organisation_id
      user_id: $user_id
    ) {
      id
    }
  }
`);

export const updateUserNotificationSettingsMutation = graphql(`
  mutation UpdateUserNotificationSettings(
    $user_id: ID!
    $gets_email_notifications: Boolean!
  ) {
    updateUserNotificationSettings(
      user_id: $user_id
      gets_email_notifications: $gets_email_notifications
    ) {
      id
      gets_email_notifications
    }
  }
`);
